/** @module @csi/widget/UserIcon */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"csi/html",
	"csi/image/_base",
	"csi/reflection"
], function(declare,_WidgetBase,html,csiImage,reflection) {
	
	return declare(_WidgetBase, {
		baseClass: "csi-user-icon",
		templateString: '<span title="${userName}"></span>',
		
		/** @property {boolean} allowName - indicate if name should be added next to icon (don't use if you need link) */
		allowName: false,
		
		/** @property {boolean} allowTooltip - indicate if icon should have tooltip or not */
		allowTooltip: true,
		
		/** @property {Cache} cache - cache to use to get data */
		cache: null,
		
		/** @property {string} userUrl - URL to user node */
		userUrl: null,
		
		postCreate: function() {
			this.inherited(arguments);

			const domNode = this.domNode;
			const cache = this.cache;
			const user = cache.get(this.userUrl);
			const image = cache.get(user.Image);
			const name = user.$Name;
			const title = this.allowTooltip ? name : "";

			const imageSpan = html.create("span", {
				"class": this.baseClass + "-image"
			}, domNode);

			if (image) {
				html.create("img", {
					src: csiImage.getImageSrc(image, null, reflection.ATTR_THUMBNAIL),
					title: title
				}, imageSpan);
			} else {
				html.create("span", {
					"class": "csiActionIcon iconUser",
					title: title
				}, imageSpan);
			}
			
			if (this.allowName) {
				html.create("span", {
					"class": this.baseClass + "-name",
					innerText: name
				}, domNode);
			}
		}
	});
});